// =============================================================================
// CONTACT FORM SECTION COMPONENT
// =============================================================================

import React from 'react';
import type { ContentComponent } from '@/types';
import { ContactForm } from '@/components/Form';

interface ContactFormSectionProps {
  component: ContentComponent;
}

export const ContactFormSection: React.FC<ContactFormSectionProps> = ({ component }) => {
  const { id, title, content } = component;

  return (
    <section id={id} className="contact-form-section section-padding">
      <div className="container">
        <div className="contact-form-wrapper">
          {title && (
            <div className="form-intro">
              <h2>{title}</h2>
              {content && <p dangerouslySetInnerHTML={{ __html: content }} />}
            </div>
          )}
          <ContactForm />
        </div>
      </div>
    </section>
  );
};

